// extracted by mini-css-extract-plugin
module.exports = {"map":"AddButton_map__YlZ8U","wrapper":"AddButton_wrapper__hRy1p","btn-add":"AddButton_btn-add__1boGa","btn":"AddButton_btn__2oF8l"};